import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { ResponseContentType, Http } from '@angular/http';
import { FileService } from 'src/app/services/services/file.service';
import * as fileSaver from 'file-saver';

@Component({
  selector: 'app-documentviewer',
  templateUrl: './documentviewer.component.html',
  styleUrls: ['./documentviewer.component.css']
})
export class DocumentviewerComponent implements OnInit {


  constructor(private http: Http, private toastr: ToastrService, private appService: AppdataService, private fileService: FileService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) { }

  //Save Validation
  submitted: boolean;
  successfully: boolean;

  @Input() trxtype: any = "";

  @Input() documentdetailsBO: any = {};


  @Output() emitData = new EventEmitter();

  viewer = 'google';
  selectedType = 'pptx';

  doc = 'https://renohrm.com/api/documents/adodksq4shov.pdf';


  ngOnInit() {


  }

  fnSetDocument() {
    this.doc = this.documentdetailsBO.filepath;


    console.log(this.doc);
  }

  public fnDeleteConfirm() {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete file?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteBtnClick()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnDeleteBtnClick() {
    try {

      var data = {
        'trxid': this.fngetDocumentDetailsid(),
        'trxtype': this.trxtype,
      }


      this.appService.fnDeleteDocumentDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnInsertActivityLog('DELETE', 0, "DOCUMENTFILES" + " - " + this.fngetDocumentDetailsid());
            this.emitData.emit(data);
            this.activeModal.close(true);

          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fngetDocumentDetailsid() {
    if (this.trxtype === 'COMPANY') {
      return this.documentdetailsBO.companydocumentdetailsid;
    }
    else if (this.trxtype === 'BRANCH') {
      return this.documentdetailsBO.branchdocumentdetailsid;
    }
    else if (this.trxtype === 'ASSET') {
      return this.documentdetailsBO.assetdocumentdetailsid;
    }
    else if (this.trxtype === 'EMPLOYEE') {
      return this.documentdetailsBO.empdocumentdetailsid;
    }
  }

  public decline() {
    this.activeModal.close(false);
  }

  fnDownload() {
    var filename = this.doc.split('/').pop();
    try {
      fileSaver.saveAs(this.doc, filename);
    }
    catch (e) {
        console.log(e)
    }

    // this.fileService.downloadFile(this.doc).subscribe(response => {
    //   let blob: any = new Blob([response], { type: 'text/json; charset=utf-8' });
    //   const url = window.URL.createObjectURL(blob);
    //   //window.open(url);
    //   //window.location.href = response.url;
    //   fileSaver.saveAs(blob, 'employees.json');
    // }), error => console.log('Error downloading the file'),
    //   () => console.info('File downloaded successfully');
  }

  downloadFile2(data: Response){
    var blob = new Blob([this.doc], { type: 'text/csv' });
    var url= window.URL.createObjectURL(blob);
    window.open(url);
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.trxtype,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
